import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Left from '@/assets/v2/left-logo.svg?react';
import Right from '@/assets/v2/right-logo.svg?react';
import TypeWriter from '@/v2/components/TypeWriter';

/**
 * 第三屏组件
 */
export const ThirdScreen = ({ isMobile, isFlat }: { isMobile: boolean; isFlat: boolean }) => {
  const { t } = useTranslation();
  const [showTips, setShowTips] = useState(false);

  if (isMobile) {
    return (
      <div className="relative flex w-full items-center justify-center overflow-hidden">
        {/* 背景板 */}
        <div className="bg-footer-bg pointer-events-none absolute inset-0 flex justify-between">
          <div className="h-full shrink-0 overflow-hidden">
            <Left className="h-full w-auto" />
          </div>
          <div className="h-full shrink-0 overflow-hidden">
            <Right className="h-full w-auto" />
          </div>
        </div>

        {/* TypeWriter 内容层 */}
        <div className="flex w-full flex-col gap-6 px-[28px] py-[24px]  md:px-[120px] lg:px-0 ">
          <TypeWriter
            hideCursorOnComplete={true}
            onComplete={() => {
              setShowTips(true);
            }}
            content={[
              { type: 'text', content: t('home.screen3.line1') },
              { type: 'newline' },
              { type: 'text', content: t('home.screen3.line2Prefix') },
              {
                type: 'image',
                src: '/assets/v2/screen3-1.png',
                width: isFlat ? 90 : 134,
                height: isFlat ? 40 : 67,
              },
              { type: 'text', content: t('home.screen3.line2Suffix') },
              {
                type: 'image',
                src: '/assets/v2/screen3-2.png',
                width: isFlat ? 90 : 134,
                height: isFlat ? 40 : 67,
              },
              { type: 'newline' },
              { type: 'text', content: t('home.screen3.line3') },
              { type: 'newline' },
              { type: 'text', content: t('home.screen3.line4Prefix') },
              {
                type: 'image',
                src: '/assets/v2/screen3-3.png',
                width: isFlat ? 90 : 134,
                height: isFlat ? 40 : 67,
              },
              { type: 'text', content: t('home.screen3.line4Suffix') },
            ]}
            className="relative z-10 text-[18px] font-semibold leading-[1.2]"
            speed={60}
            effect="fade"
            cursorStyle="line"
          />
          <div className="text-content-title z-10 flex gap-[10%] font-normal leading-normal opacity-80">
            <div className="flex flex-col gap-3">
              <div>{t('home.screen3.tip1')}</div>
              <div>{t('home.screen3.tip2')}</div>
            </div>
            <div>{t('home.screen3.tip3')}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-background-primary relative mx-auto flex w-full items-center justify-center overflow-hidden">
      {/* 背景板 - 使用绝对定位和100%高度，SVG放在容器内限制溢出 */}
      <div className="bg-footer-bg pointer-events-none absolute inset-0 flex justify-between">
        <div className="h-full shrink-0 overflow-hidden">
          <Left className="h-full w-auto" style={{ maxHeight: '100%' }} />
        </div>
        <div className="h-full shrink-0 overflow-hidden">
          <Right className="h-full w-auto" style={{ maxHeight: '100%' }} />
        </div>
      </div>

      {/* TypeWriter 内容层 */}
      <div className="w-full max-w-screen-lg">
        <div className="flex w-full flex-col gap-6 p-[88px] md:px-[120px] lg:px-0">
          <TypeWriter
            hideCursorOnComplete={true}
            onComplete={() => {
              setShowTips(true);
            }}
            content={[
              { type: 'text', content: t('home.screen3.line1') },
              { type: 'newline' },
              { type: 'text', content: t('home.screen3.line2Prefix') },
              {
                type: 'image',
                src: '/assets/v2/screen3-1.png',
                width: isFlat ? 90 : 134,
                height: isFlat ? 40 : 67,
              },
              { type: 'text', content: t('home.screen3.line2Suffix') },
              {
                type: 'image',
                src: '/assets/v2/screen3-2.png',
                width: isFlat ? 90 : 134,
                height: isFlat ? 40 : 67,
              },
              { type: 'newline' },
              { type: 'text', content: t('home.screen3.line3') },
              { type: 'newline' },
              { type: 'text', content: t('home.screen3.line4Prefix') },
              {
                type: 'image',
                src: '/assets/v2/screen3-3.png',
                width: isFlat ? 90 : 134,
                height: isFlat ? 40 : 67,
              },
              { type: 'text', content: t('home.screen3.line4Suffix') },
            ]}
            className="relative z-10 min-h-[312px] text-[28px] font-semibold leading-[1.2] md:text-[48px]"
            speed={60}
            effect="fade"
            cursorStyle="line"
          />
          <div className="min-h-12">
            <div
              className={`text-content-title z-10 flex gap-[10%] font-normal leading-normal transition-opacity duration-300 ${showTips ? 'opacity-80' : 'opacity-0'}`}
            >
              <div className="flex flex-col gap-3">
                <div>{t('home.screen3.tip1')}</div>
                <div>{t('home.screen3.tip2')}</div>
              </div>
              <div>{t('home.screen3.tip3')}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThirdScreen;
